export class CadastroHelprev {
    info: Array<any> = [];
}
